"use client";

import { createContext, useContext } from "react";
export const ViewStepContext = createContext<((index: number) => void) | undefined>(undefined);
export function useLocalViewStep() { return useContext(ViewStepContext); }

export const VerificationQrContext = createContext<((image: string | null) => void) | undefined>(undefined);
